export default __webpack_public_path__ + "static/media/flag-haiti.e2d7b5fa.svg";